import { z } from 'zod';

export const TeamInfoSchema = z.object({
    type: z.literal('team-info'),
});
export type TeamInfo = z.infer<typeof TeamInfoSchema>;
